<script>
import { useAlert, useTrack } from 'dashboard/composables';
import BotMetrics from './components/BotMetrics.vue';
import ReportFilters from './components/ReportFilters.vue';
import { GROUP_BY_FILTER } from './constants';
import ReportContainer from './ReportContainer.vue';
import { REPORTS_EVENTS } from '../../../../helper/AnalyticsHelper/events';
import ReportHeader from './components/ReportHeader.vue';
import DownloadPdfButton from 'dashboard/components/reports/DownloadPdfButton.vue';

export default {
  name: 'BotReports',
  components: {
    BotMetrics,
    ReportHeader,
    DownloadPdfButton,
    ReportFilters,
    ReportContainer,
  },
  data() {
    return {
      from: 0,
      to: 0,
      groupBy: GROUP_BY_FILTER[1],
      reportKeys: {
        BOT_RESOLUTION_COUNT: 'bot_resolutions_count',
        BOT_HANDOFF_COUNT: 'bot_handoffs_count',
      },
      businessHours: false,
      inboxId: null,
    };
  },
  computed: {
    // Com eles, os numeros de resolvidas e passadas pelo robo abrem as conversas (ReportDrilldownPanel).
    drilldownFilters() {
      const { from, to, inboxId } = this;
      return { from, to, type: 'account', businessHours: false, inboxId };
    },
    requestPayload() {
      return {
        from: this.from,
        to: this.to,
        inboxId: this.inboxId,
        inbox_id: this.inboxId || undefined,
      };
    },
  },
  methods: {
    fetchAllData() {
      this.fetchBotSummary();
      this.fetchChartData();
    },
    fetchBotSummary() {
      try {
        this.$store.dispatch('fetchBotSummary', this.getRequestPayload());
      } catch {
        useAlert(this.$t('REPORT.SUMMARY_FETCHING_FAILED'));
      }
    },
    fetchChartData() {
      Object.keys(this.reportKeys).forEach(async key => {
        try {
          await this.$store.dispatch('fetchAccountReport', {
            metric: this.reportKeys[key],
            ...this.getRequestPayload(),
          });
        } catch {
          useAlert(this.$t('REPORT.DATA_FETCHING_FAILED'));
        }
      });
    },
    getRequestPayload() {
      const { from, to, groupBy, businessHours, inboxId } = this;

      return {
        from,
        to,
        groupBy: groupBy?.period,
        businessHours,
        inboxId,
      };
    },
    onFilterChange({ from, to, groupBy, businessHours, inboxId }) {
      this.from = from;
      this.to = to;
      this.groupBy = groupBy;
      this.businessHours = businessHours;
      this.inboxId = inboxId || null;
      this.fetchAllData();

      useTrack(REPORTS_EVENTS.FILTER_REPORT, {
        filterValue: { from, to, groupBy, businessHours },
        reportType: 'bots',
      });
    },
  },
};
</script>

<template>
  <ReportHeader :header-title="$t('BOT_REPORTS.HEADER')">
    <DownloadPdfButton report-type="bot" :filters="requestPayload" />
    <template #filters>
      <ReportFilters
        :show-entity-filter="false"
        show-group-by
        :show-business-hours="false"
        @filter-change="onFilterChange"
      />
    </template>
  </ReportHeader>
  <div class="flex flex-col gap-4">
    <BotMetrics :filters="requestPayload" />
    <ReportContainer
      account-summary-key="getBotSummary"
      summary-fetching-key="getBotSummaryFetchingStatus"
      :group-by="groupBy"
      :report-keys="reportKeys"
      :drilldown-filters="drilldownFilters"
    />
  </div>
</template>
